<template>
	<v-menu :close-on-content-click="true" z-index="99999" location="end" transition="scale-transition">
		<v-card class="color-picker-card pa-2" elevation="6">
			<div class="color-picker ga-1">
				<div
					v-for="(color, index) in colors"
					:key="index"
					:data-test-id="`annotation-color-picker-swatch-${color.slice(1)}`"
					class="cursor-pointer scale-transition"
					:class="{ border: selectedColor === color }"
					:style="{ backgroundColor: color }"
					tile
					@click="selectColor(color)"></div>
			</div>
		</v-card>
		<template #activator="{ props }">
			<div ref="activator" v-bind="props" data-test-id="annotation-color-picker-button" class="pa-3">
				<svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#paint0_angular_shared_color_picker_clip_path)" data-figma-skip-parse="true">
						<g transform="matrix(0 0.0125 -0.013 0 14 13)">
							<foreignObject x="-1080" y="-1080" width="2160" height="2160"
								><div
									xmlns="http://www.w3.org/1999/xhtml"
									style="
										background: conic-gradient(
											from 90deg,
											rgba(251, 21, 21, 1) 0deg,
											rgba(0, 112, 255, 1) 126.346deg,
											rgba(255, 184, 0, 1) 235.385deg,
											rgba(2, 181, 84, 1) 315deg,
											rgba(251, 21, 21, 1) 360deg
										);
										height: 100%;
										width: 100%;
										opacity: 1;
									"></div
							></foreignObject>
						</g>
					</g>
					<ellipse cx="14" cy="13" rx="13" ry="12.5" />
					<defs>
						<clipPath id="paint0_angular_shared_color_picker_clip_path">
							<ellipse cx="14" cy="13" rx="13" ry="12.5" />
						</clipPath>
					</defs>
				</svg>
			</div>
		</template>
	</v-menu>
</template>

<script lang="ts" setup>
	import { ref, watch } from "vue";

	const ANNOTATION_COLORS = [
		"#0070FF",
		"#5CA4FF",
		"#B1D8FF",
		"#36CCED",
		"#02B555",
		"#099B9B",
		"#865EFA",
		"#F91101",
		"#FF460B",
		"#FF8A00",
		"#FFD41B",
		"#DEFFF9",
		"#E6FFE3",
		"#E0E0E0",
		"#FFE2E8",
		"#03011D"
	];

	function getRandomAnnotationColor(skipColor?: string): string {
		const available = skipColor ? ANNOTATION_COLORS.filter((color) => color !== skipColor) : ANNOTATION_COLORS;
		return available[Math.floor(Math.random() * available.length)];
	}

	const props = defineProps<{
		modelValue: string;
	}>();

	const emits = defineEmits<{
		(event: "update:modelValue", color: string): void;
	}>();

	const colors = ANNOTATION_COLORS;
	const selectedColor = ref<string>(props.modelValue || getRandomAnnotationColor());

	if (!props.modelValue) {
		emits("update:modelValue", selectedColor.value);
	}

	watch(
		() => props.modelValue,
		(newValue) => {
			if (newValue) {
				selectedColor.value = newValue;
			} else {
				selectedColor.value = getRandomAnnotationColor(selectedColor.value);
				emits("update:modelValue", selectedColor.value);
			}
		}
	);

	function selectColor(color: string): void {
		selectedColor.value = color;
		emits("update:modelValue", color);
	}
</script>

<style scoped>
	.color-picker {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-template-rows: repeat(4, 1fr);
		width: 180px;
		height: 180px;
	}
</style>
